import React from 'react';

// import styled components
import { Grid } from '../styled';
import { FinancingForContent } from './styled';

const FinancingFor = () => (
  <section aria-label="Financing for condos or condo hotels (condotel)">
    <Grid>
      <FinancingForContent>
        <h1>Financing for Condos or Condo Hotels (Condotel)</h1>
        <p>
          Purchasing a condo or condominium unit is one of the fastest growing
          trends across the nation. There are a couple of options for financing
          a condo - if the condo meets certain requirements, you'll be offered
          the traditional conventional loan, however if a condo is not eligible,
          you may need to look for a lender that can offer innovative financing
          solutions. Good news - we offer both!
        </p>
      </FinancingForContent>
    </Grid>
  </section>
);

export default FinancingFor;
